import { Roster } from '@axys-notes/common';

/**
 * Détermine si un utilisateur peut éditer un enregistrement.
 * L'utilisateur peut éditer s'il est :
 * - Celui qui a soumis l'enregistrement (submittedBy)
 * - OU un organisateur du meeting (organizer dans le roster)
 */
export function canEditRecording(
  userId: string | undefined,
  submittedBy: string,
  roster: Roster
): boolean {
  if (!userId) {
    return false;
  }

  const isSubmitter = userId === submittedBy;
  const isOrganizer = roster.some(
    (participant) => participant.id === userId && participant.organizer
  );

  return isSubmitter || isOrganizer;
}
